import { ProductOption } from "@lib/swell/storefront-data-hooks/src/types"
import { classNames } from "core/utils"
import { useFormikContext, useField } from "formik"
import { useEffect, useCallback } from "react"
import { Selection } from "./ProductForm"
interface TextFieldProps {
  option: ProductOption
  updateTextFieldSelectionChange: any
  selections: Selection[]
}
const LongTextField = ({ option, updateTextFieldSelectionChange, selections }: TextFieldProps) => {
  const { id, name, input_hint, description } = option
  const [input] = useField(name)

  const hidden = useCallback(() => {
    if (!option.parent_id) {
      return false
    }
    const parentSelection = selections.find((selection) => {
      return selection.optionId == option.parent_id
    })
    if (!parentSelection) return false
    if (option.parent_value_ids) {
      return !option.parent_value_ids.some((id: string) => id === parentSelection.id)
    } else {
      return !parentSelection.value
    }
    return false
  }, [selections])

  const hiddenValue = hidden()
  useEffect(() => {
    if (hiddenValue) {
      input.onChange({ target: { value: "", name } })
    }
  }, [hiddenValue])

  const { isSubmitting } = useFormikContext()
  return (
    <div className={classNames(hidden() ? "hidden" : "", "rounded-lg border border-gray-300 p-4")}>
      <label htmlFor="email-address" className="block text-sm font-medium text-gray-700">
        {name}
      </label>
      <span className="text-sm text-gray-500">{description}</span>

      <div className="mt-1">
        <textarea
          rows={4}
          {...input}
          placeholder={input_hint}
          disabled={isSubmitting}
          onChange={(event: any) => {
            input.onChange({ target: { value: event.target.value, name } })
            updateTextFieldSelectionChange(name, id, event.target.value)
          }}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={""}
        />
      </div>
    </div>
  )
}
export default LongTextField
